// composables/useSmartRedirect.ts - 智能重定向封装（设置 store + 路由跳转 + 提示）
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { useFileRedirectStore } from '~/stores/fileRedirect'
import { useFileTypeDetection } from '~/composables/useFileTypeDetection'
import { useI18n } from 'vue-i18n'

export function useSmartRedirect() {
  const router = useRouter()
  const route = useRoute()
  const fileRedirect = useFileRedirectStore()
  const { categoryToPath } = useFileTypeDetection()
  const { t } = useI18n()

  const smartRedirect = async (file: File, fromCategory?: string, toCategory?: string | null) => {
    if (!toCategory) return false
    const targetPath = categoryToPath(toCategory as any)

    // 若目标与当前相同，则不跳转，返回 false 让调用方自行处理
    if (route.path === targetPath) return false

    // 设置待传文件并跳转
    fileRedirect.setPending(file, { from: fromCategory, target: toCategory })
    try {
      await router.push(targetPath)
      const targetLabelMap: Record<string, string> = {
        pdf: t('smartRedirect.labels.pdf'),
        office: t('smartRedirect.labels.office'),
        ebook: t('smartRedirect.labels.ebook'),
        subtitle: t('smartRedirect.labels.subtitle')
      }
      const label = targetLabelMap[toCategory] || t('smartRedirect.labels.default')
      ElMessage && ElMessage.info(t('smartRedirect.messages.redirected', { label }))
      return true
    } catch (e) {
      // 跳转失败：清理并返回失败
      fileRedirect.clear()
      return false
    }
  }

  return { smartRedirect }
}
